module.exports = __webpack_public_path__ + "img/shop.03e22e22.jpg";